(function (EF) {
  EF.services = EF.services || {};

  EF.services.audio_hotspot = function (elementId, audioFile, popupContentId, moreToDo, options) {
    function elementClick() {
      if (!EF.services.audio_player.playing) {
        $('#' + EF.services.audio_hotspot.overlayId).show();
        if (options.customDisplayFunction) {
          options.customDisplayFunction($('#' + popupContentId));
        } else {
          $('#' + popupContentId).show();
        }
        var continueButton = options.customContinueButtonId
          ? $('#' + options.customContinueButtonId)
          : $('#' + EF.services.audio_hotspot.continueButtonId);
        continueButton.show();
        if (audioFile) {
          disableContinueButton(continueButton);
          if (options.continueCss) {
            continueButton.css(options.continueCss);
          }
          EF.services.audio_player.initAudio(
            audioFile,
            { autoPlay: true, moreToDo: moreToDo },
            {
              ended: function () {
                enableContinueButton(continueButton);
                if (options.continueOnAudioEnd) {
                  continueClick();
                }
                if (options.audioEndedCallback) {
                  options.audioEndedCallback(moreToDo);
                }
              },
            }
          );
        } else {
          enableContinueButton(continueButton);
        }
        if (options.clickCallback) {
          options.clickCallback();
        }
      }
    }
    $('#' + elementId).click(elementClick);

    function disableContinueButton(continueButton) {
      continueButton.off('click');
      continueButton.css('opacity', '.4');
      continueButton.attr('disabled', 'disabled');
    }

    function enableContinueButton(continueButton) {
      continueButton.removeAttr('disabled');
      continueButton.css('opacity', '1');
      continueButton.on('click', continueClick);
      if (options.continueCss) {
        continueButton.css(options.continueCss);
      }
    }

    function continueClick() {
      $('#' + EF.services.audio_hotspot.overlayId).hide();
      if (options.customHideFunction) {
        options.customHideFunction($('#' + popupContentId));
      } else {
        $('#' + popupContentId).hide();
      }
      var continueButton = options.customContinueButtonId
        ? $('#' + options.customContinueButtonId)
        : $('#' + EF.services.audio_hotspot.continueButtonId);
      continueButton.hide();
      if (options.continueCallback) options.continueCallback();
    }
  };

  EF.services.audio_hotspot.init = function (continueButtonId, overlayId) {
    EF.services.audio_hotspot.continueButtonId = continueButtonId;
    EF.services.audio_hotspot.overlayId = overlayId;
  };
})(window.EF);
